// extracted by mini-css-extract-plugin
module.exports = {"root":"_7b6bbd","lastUpdate":"_0a72cf","contributors":"_387f98","avatars":"_4b5098","legalText":"_84e4de"};